import React from 'react';
import { Route, Switch, useParams } from 'react-router-dom';

import Summary from './components/Summary/Summary';

import { buildAdviseeActionPlanUri } from 'utils/routes';

const ActionPlan = ({ actionPlans }) => {
  const { id: adviseeId } = useParams();
  return (
    <Switch>
      <Route path={buildAdviseeActionPlanUri(adviseeId)}>
        <Summary actionPlans={actionPlans} />
      </Route>
    </Switch>
  );
};

export default ActionPlan;
